import React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import { verifyCoachKyc } from '../../services/apiService';
import { toast } from 'react-toastify';

export default function KycDetailModal({
  coachDetail,
  closeModal,
  refreshKycList,
}) {
  const completeVerification = async () => {
    try {
      await verifyCoachKyc({
        userId: coachDetail.userId,
        status: 'APPROVED',
      });
      toast.success('Verification Approved');
      closeModal();
      refreshKycList();
    } catch (error) {
      console.error(error);
      toast.error('Verification Update Failed');
    }
  };

  const rejectVerification = async () => {
    try {
      await verifyCoachKyc({
        userId: coachDetail.userId,
        status: 'REJECTED',
      });
      toast.success('Verification Rejected');
      closeModal();
      refreshKycList();
    } catch (error) {
      console.error(error);
      toast.error('Verification Reject Failed');
    }
  };
  return (
    <div className='bg-white p-4 text-left rounded'>
      <h1 className='ml-3 capitalize  text-2xl mt-4 text-green-c1 font-medium'>
        {coachDetail?.firstName} KYC Details
      </h1>
      <section className='ml-2 bg-white py-4 px-4 '>
        <h2 className='user-heading text-lg text-green-c1 font-medium my-5'>
          Aadhaar Details
        </h2>
        <section className='md:ml-4 grid grid-cols-1 md:grid-cols-2 gap-8 text-sm '>
          <div>
            <p className='mb-1 opacity-30'>Aadhaar Number</p>
            <p>{coachDetail?.aadhaarNo}</p>
          </div>
          <div className='flex flex-col capitalize'>
            <p className='mb-1 opacity-30'>Upload Pancard</p>

            <a
              href={coachDetail?.aadhaarS3Url}
              rel='noreferrer'
              target='_blank'
            >
              {' '}
              <GetAppIcon className='text-blue-400 mr-2' />
              Aadhaar.pdf
            </a>
          </div>

          <div className='col-span-2'>
            <p className='mb-1 opacity-30'>Address on Aadhaar</p>
            <p className='break-words w-5/6'>{coachDetail?.address}</p>
          </div>
        </section>
      </section>
      <section className='ml-2 bg-white  py-4 px-4'>
        <h2 className='user-heading text-lg text-green-c1 font-medium my-5'>
          PAN Details
        </h2>
        <section className='md:ml-4 grid grid-cols-1 md:grid-cols-2 gap-8 text-sm '>
          <div>
            <p className='mb-1 opacity-30'>Pan Number</p>
            <p>{coachDetail?.panNo}</p>
          </div>
          <div className='flex flex-col capitalize'>
            <p className='mb-1 opacity-30'>Upload Pancard</p>

            <a href={coachDetail?.panS3Url} rel='noreferrer' target='_blank'>
              {' '}
              <GetAppIcon className='text-blue-400 mr-2' />
              PAN.pdf
            </a>
          </div>
        </section>
      </section>
      <div className='flex gap-x-40 mx-4 flex-wrap items-center justify-between my-5'>
        <button
          onClick={completeVerification}
          className='flex items-center capitalize w-auto gap-1 bg-blue-c1 text-white px-4 py-3   rounded'
          color='primary'
        >
          complete verification
        </button>
        <button
          onClick={rejectVerification}
          className='flex items-center capitalize w-auto gap-1 bg-red-100 text-red-600 px-4 py-3   rounded'
          color='primary'
        >
          reject verification
        </button>
        {/* <p
          onClick={() => setShowDetailModal(false)}
          className='text-gray-400 mr-6 cursor-pointer'
        >
          Skip for now
        </p> */}
      </div>
    </div>
  );
}
